import { Joi, objectSchemaOf, actionCreator } from '../helpers';
import { VISION_OUTPUT } from './topics';
import type { PersonType } from './personIdentified';
import { personTypesSchema } from './personIdentified';

export const FACE_UPDATED = 'VISION/FACE_UPDATED';

export interface IFaceUpdatedActionPayload {
  faceId: string;
  faceToken: string;
  organisationId: string;
  createdOn: number;
  lastUpdatedOn: number;
  type: PersonType;
  staffId?: string;
  visitorId?: string;
}

export interface IFaceUpdatedAction {
  type: typeof FACE_UPDATED;
  payload: IFaceUpdatedActionPayload;
}

export const faceUpdatedActionSchema = objectSchemaOf<IFaceUpdatedAction>({
  type: Joi.string().valid(FACE_UPDATED).required(),
  payload: objectSchemaOf<IFaceUpdatedActionPayload>({
    faceId: Joi.string().required(),
    faceToken: Joi.string().required(),
    organisationId: Joi.string().required(),
    createdOn: Joi.number().required(),
    lastUpdatedOn: Joi.number().required(),
    type: personTypesSchema.required(),
    staffId: Joi.string().optional(),
    visitorId: Joi.string().optional(),
  }).required(),
});

export const faceUpdated = actionCreator({
  type: FACE_UPDATED,
  schema: faceUpdatedActionSchema,
  topic: VISION_OUTPUT,
});
